module.exports = __webpack_public_path__ + "static/media/0_2018_10_13.1b551d6f.jpg";